import LANGUAGES_NAMES from 'utils/Language/languageNames';
import translations from 'utils/Language/translations';

import { ReduxStore } from '../types';

export function selectProfiles(store: ReduxStore) {
    const appConfig = store.config.app;

    return appConfig.miscellanious?.profiles || [];
}

export function selectLanguagesList(store: ReduxStore) {
    const appConfig = store.config.app;
    const languagesSource = appConfig.languages || translations;

    return Object.keys(languagesSource).map((key) => ({
        id: key,
        title:
            // @ts-ignore
            LANGUAGES_NAMES[key as keyof typeof LANGUAGES_NAMES].key ||
            LANGUAGES_NAMES[key as keyof typeof LANGUAGES_NAMES].englishName,
    }));
}
